import TimeUtil from 'utils/time-util'
import CustomerOrderStatusBadge from 'domains/customer-order/atoms/status-badge/customer-order-status-badge'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const propTypes = {
  order              : PropTypes.object,
  showCustomerFields : PropTypes.bool
}

/**
 * Row to show some attribute of ::Customer::Order
 * @param {Object} order - Customer::Order
 * @param {Boolean} order - Show customer related data
 */

const CustomerOrderTableRow = ({
  order,
  showCustomerFields
}) => {

  const rowObjects = {
    orderNumber: {
      content: order.number
    },
    orderDate: {
      content: TimeUtil.format(order.order_date)
    },
    status: {
      content: <CustomerOrderStatusBadge status={ order.status } />
    },
    paymentMethod: {
      content: order.payment_method_name
    },
    discountCode: {
      content: order.discount_code
    },
    orderSkus: {
      content: (
        <>
          {
            order.order_items.map((item, key) => <span key={ `item-${item.sku}-${key}` }>{ item.sku }</span>)
              .reduce((prev, curr, key) => [ prev, <br key={ key } />, curr ])
          }
        </>
      )
    },
    orderAffiliateName: {
      content: order.affiliate_name
    },
    orderCustomer: {
      tdStyle : { whiteSpace: 'pre-wrap' },
      content : (
        <>
          {
            [
              order.customer.name,
              order.customer.email || '-',
              order.customer.mobile || '-'
            ].join('\n')
          }
        </>
      )
    }
  }

  return (
    <tr>
      {
        Object.keys(rowObjects).map((key) => {
          // To hide customer related fields
          // because its not needed to be displayed in page like Customer Detail Page
          const hideCustomerField = !showCustomerFields && key === 'orderCustomer'
          if (hideCustomerField) return

          return (
            <td key={ `row${order.id}-${key}` }>
              <Link
                style={{ color: '#616d8a' }}
                to={ `/app/customer-orders/${order.id}` }
              >
                <div
                  className='h-100'
                  style={{ ...rowObjects[key].tdStyle }}
                >
                  { rowObjects[key].content }
                </div>
              </Link>
            </td>
          )
        })
      }
    </tr>
  )
}

CustomerOrderTableRow.propTypes = propTypes

export default CustomerOrderTableRow